export default (function () {
    const gallery = document.querySelector('[data-product-gallery]')

    if (!gallery) return

    const wrappers = gallery.querySelectorAll('[data-product-gallery-image-wrapper]')

    wrappers.forEach(wrapper => {
        const img = wrapper.querySelector('img')

        wrapper.addEventListener('mouseenter', () => {
            img.style.transform = 'scale(2)'
        })

        wrapper.addEventListener('mousemove', e => {
            const rect = wrapper.getBoundingClientRect()
            const x = ((e.clientX - rect.left) / rect.width) * 100
            const y = ((e.clientY - rect.top) / rect.height) * 100
            img.style.transformOrigin = `${x}% ${y}%`
        })

        wrapper.addEventListener('mouseleave', () => {
            img.style.transform = 'scale(1)'
            img.style.transformOrigin = 'center center'
        })
    })
})
